module.exports = __webpack_public_path__ + "static/media/final-step.77043b9d.jpg";